import React, { useState } from 'react';
import { PlusIcon, BotIcon, UsersIcon, CheckCircleIcon, BarChart2Icon, ArrowRightIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
export const ConversAI = () => {
  const [sortField, setSortField] = useState<'name' | 'platform' | 'status' | 'conversations' | 'successRate'>('conversations');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const bots = [{
    name: 'Support-Assistent',
    platform: 'WhatsApp',
    status: 'Online',
    conversations: 128,
    successRate: '92%'
  }, {
    name: 'Lead-Qualifizierer',
    platform: 'Website',
    status: 'Online',
    conversations: 87,
    successRate: '78%'
  }, {
    name: 'Terminvereinbarung',
    platform: 'WhatsApp',
    status: 'Online',
    conversations: 53,
    successRate: '85%'
  }, {
    name: 'Feedback-Sammler',
    platform: 'E-Mail + WhatsApp',
    status: 'Geplant',
    conversations: 0,
    successRate: '0%'
  }];
  const handleSort = (field: typeof sortField) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  const renderSortIndicator = (field: typeof sortField) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? <ChevronUpIcon size={16} className="ml-1" data-id="element-79" /> : <ChevronDownIcon size={16} className="ml-1" data-id="element-80" />;
  };
  const sortedBots = [...bots].sort((a, b) => {
    let compareA = a[sortField];
    let compareB = b[sortField];
    // Convert percentage strings to numbers
    if (sortField === 'successRate') {
      compareA = parseFloat(compareA);
      compareB = parseFloat(compareB);
    }
    if (compareA < compareB) return sortDirection === 'asc' ? -1 : 1;
    if (compareA > compareB) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
  return <div className="space-y-6" data-id="element-81">
      <div className="flex items-center justify-between" data-id="element-82">
        <h2 className="text-xl font-semibold text-gray-800" data-id="element-83">
          Chatbots & Automatisierungen
        </h2>
        <button className="px-4 py-2 bg-purple-500 rounded-lg text-sm font-medium text-white flex items-center hover:bg-purple-600" data-id="element-84">
          <PlusIcon size={16} className="mr-2" data-id="element-85" />
          Neuen Bot erstellen
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-86">
        {[{
        title: 'Aktive Bots',
        value: '4',
        icon: <BotIcon size={18} className="text-purple-500" data-id="element-87" />
      }, {
        title: 'Konversationen heute',
        value: '37',
        icon: <BotIcon size={18} className="text-purple-500" data-id="element-88" />
      }, {
        title: 'Automatisierte Antworten',
        value: '89%',
        icon: <CheckCircleIcon size={18} className="text-green-500" data-id="element-89" />
      }].map((stat, index) => <div key={index} className="bg-white rounded-lg shadow p-5" data-id="element-90">
            <div className="flex justify-between items-center mb-4" data-id="element-91">
              <p className="text-sm font-medium text-gray-500" data-id="element-92">{stat.title}</p>
              <div className="p-2 rounded-full bg-gray-100" data-id="element-93">{stat.icon}</div>
            </div>
            <p className="text-2xl font-bold text-gray-800" data-id="element-94">{stat.value}</p>
          </div>)}
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-95">
        <div className="p-5 border-b border-gray-200" data-id="element-96">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-97">Meine Chatbots</h3>
          <p className="text-sm text-gray-500 mt-1" data-id="element-98">
            Übersicht und Status Ihrer konfigurierten Chatbots
          </p>
        </div>
        <div className="overflow-x-auto" data-id="element-99">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-100">
            <thead className="bg-gray-50" data-id="element-101">
              <tr data-id="element-102">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('name')} data-id="element-103">
                  <div className="flex items-center" data-id="element-104">
                    Bot-Name
                    {renderSortIndicator('name')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('platform')} data-id="element-105">
                  <div className="flex items-center" data-id="element-106">
                    Plattform
                    {renderSortIndicator('platform')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('status')} data-id="element-107">
                  <div className="flex items-center" data-id="element-108">
                    Status
                    {renderSortIndicator('status')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('conversations')} data-id="element-109">
                  <div className="flex items-center" data-id="element-110">
                    Konversationen
                    {renderSortIndicator('conversations')}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100" onClick={() => handleSort('successRate')} data-id="element-111">
                  <div className="flex items-center" data-id="element-112">
                    Erfolgsrate
                    {renderSortIndicator('successRate')}
                  </div>
                </th>
                <th scope="col" className="relative px-6 py-3" data-id="element-113">
                  <span className="sr-only" data-id="element-114">Aktionen</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-115">
              {sortedBots.map((bot, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-116">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-117">
                    <div className="flex items-center" data-id="element-118">
                      <div className="flex-shrink-0 h-10 w-10 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-119">
                        <BotIcon size={18} className="text-purple-500" data-id="element-120" />
                      </div>
                      <div className="ml-4" data-id="element-121">
                        <div className="text-sm font-medium text-gray-900" data-id="element-122">
                          {bot.name}
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-123">
                          Erstellt am 10.06.2023
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-124">
                    <div className="text-sm text-gray-900" data-id="element-125">{bot.platform}</div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-126">
                    <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${bot.status === 'Online' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-127">
                      {bot.status}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-128">
                    <div className="text-sm text-gray-900" data-id="element-129">
                      {bot.conversations}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-130">
                    <div className="text-sm text-gray-900" data-id="element-131">
                      {bot.successRate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-132">
                    <button className="text-purple-500 hover:text-purple-700 flex items-center" data-id="element-133">
                      Bearbeiten
                      <ArrowRightIcon size={14} className="ml-1" data-id="element-134" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-135">
        <div className="bg-white rounded-lg shadow" data-id="element-136">
          <div className="p-5 border-b border-gray-200" data-id="element-137">
            <h3 className="text-lg font-medium text-gray-800" data-id="element-138">
              Aktuelle Konversationen
            </h3>
            <p className="text-sm text-gray-500 mt-1" data-id="element-139">
              Laufende Chats, die möglicherweise Ihre Aufmerksamkeit benötigen
            </p>
          </div>
          <div className="p-5 space-y-4" data-id="element-140">
            {[{
            name: 'Max Schmidt',
            company: 'Digital Solutions GmbH',
            message: 'Ich hätte Interesse an einem Beratungstermin nächste Woche.',
            time: 'Vor 5 Minuten',
            bot: 'Lead-Qualifizierer',
            status: 'Menschliche Hilfe benötigt'
          }, {
            name: 'Sarah Weber',
            company: 'Tech Innovate AG',
            message: 'Vielen Dank für die Information. Können Sie mir ein Angebot zusenden?',
            time: 'Vor 12 Minuten',
            bot: 'Support-Assistent',
            status: 'Automatisch beantwortet'
          }, {
            name: 'Thomas Müller',
            company: 'IT Services GmbH',
            message: 'Ich habe eine Frage zur Enterprise-Version Ihres Produkts.',
            time: 'Vor 25 Minuten',
            bot: 'Support-Assistent',
            status: 'Automatisch beantwortet'
          }].map((conversation, index) => <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer" data-id="element-141">
                <div className="flex justify-between items-start" data-id="element-142">
                  <div className="flex items-start" data-id="element-143">
                    <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center" data-id="element-144">
                      <UsersIcon size={18} className="text-blue-500" data-id="element-145" />
                    </div>
                    <div className="ml-3" data-id="element-146">
                      <div className="text-sm font-medium text-gray-900" data-id="element-147">
                        {conversation.name}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-148">
                        {conversation.company}
                      </div>
                      <div className="text-sm text-gray-600 mt-2" data-id="element-149">
                        "{conversation.message}"
                      </div>
                      <div className="flex items-center mt-2 space-x-3" data-id="element-150">
                        <span className="text-xs text-gray-500" data-id="element-151">
                          {conversation.time}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-152">•</span>
                        <span className="text-xs text-gray-500" data-id="element-153">
                          Bot: {conversation.bot}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${conversation.status === 'Menschliche Hilfe benötigt' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`} data-id="element-154">
                    {conversation.status}
                  </div>
                </div>
              </div>)}
            <div className="text-center mt-4" data-id="element-155">
              <button className="text-purple-500 text-sm font-medium hover:text-purple-600" data-id="element-156">
                Alle Konversationen anzeigen
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow" data-id="element-157">
          <div className="p-5 border-b border-gray-200" data-id="element-158">
            <div className="flex justify-between items-center" data-id="element-159">
              <h3 className="text-lg font-medium text-gray-800" data-id="element-160">
                Bot-Performance
              </h3>
              <BarChart2Icon size={18} className="text-gray-400" data-id="element-161" />
            </div>
          </div>
          <div className="p-5" data-id="element-162">
            <div className="space-y-4" data-id="element-163">
              <div data-id="element-164">
                <div className="flex justify-between items-center mb-2" data-id="element-165">
                  <span className="text-sm font-medium text-gray-700" data-id="element-166">
                    Fragen beantwortet
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-167">89%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-168">
                  <div className="bg-purple-500 h-2 rounded-full" style={{
                  width: '89%'
                }} data-id="element-169"></div>
                </div>
              </div>
              <div data-id="element-170">
                <div className="flex justify-between items-center mb-2" data-id="element-171">
                  <span className="text-sm font-medium text-gray-700" data-id="element-172">
                    Weiterleitung an Menschen
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-173">11%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-174">
                  <div className="bg-red-500 h-2 rounded-full" style={{
                  width: '11%'
                }} data-id="element-175"></div>
                </div>
              </div>
              <div data-id="element-176">
                <div className="flex justify-between items-center mb-2" data-id="element-177">
                  <span className="text-sm font-medium text-gray-700" data-id="element-178">
                    Kundenzufriedenheit
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-179">92%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-180">
                  <div className="bg-green-500 h-2 rounded-full" style={{
                  width: '92%'
                }} data-id="element-181"></div>
                </div>
              </div>
              <div data-id="element-182">
                <div className="flex justify-between items-center mb-2" data-id="element-183">
                  <span className="text-sm font-medium text-gray-700" data-id="element-184">
                    Durchschnittliche Antwortzeit
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-185">
                    8 Sekunden
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-186">
                  <div className="bg-blue-500 h-2 rounded-full" style={{
                  width: '95%'
                }} data-id="element-187"></div>
                </div>
              </div>
              <div className="text-center mt-6" data-id="element-188">
                <button className="text-purple-500 text-sm font-medium hover:text-purple-600" data-id="element-189">
                  Detaillierte Analysen anzeigen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};